var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupcaravans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.818 7.56213H15.7148V10.2976H19.818V7.56213Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8183 10.9819H15.7151C15.3321 10.9819 15.0312 10.681 15.0312 10.298V7.56258C15.0312 7.17962 15.3321 6.87872 15.7151 6.87872H19.8183C20.2012 6.87872 20.5021 7.17962 20.5021 7.56258V10.298C20.5021 10.681 20.2012 10.9819 19.8183 10.9819ZM16.399 9.61416H19.1344V8.24644H16.399V9.61416Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6124 7.56213H7.50928V10.2976H11.6124V7.56213Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6117 10.9819H7.50857C7.1256 10.9819 6.82471 10.681 6.82471 10.298V7.56258C6.82471 7.17962 7.1256 6.87872 7.50857 6.87872H11.6117C11.9947 6.87872 12.2956 7.17962 12.2956 7.56258V10.298C12.2956 10.681 11.9947 10.9819 11.6117 10.9819ZM8.19242 9.61416H10.9279V8.24644H8.19242V9.61416Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8698 23.2649H5.47087C2.44821 23.2649 0 20.8167 0 17.794V10.9828C0 8.37043 1.38141 4.93746 3.13208 3.15943C4.89644 1.39507 8.31572 0 10.9417 0H21.8698C24.8925 0 27.3407 2.44821 27.3407 5.47087V17.7803C27.3407 20.803 24.8925 23.2512 21.8698 23.2512V23.2649ZM10.9417 2.74911C9.05429 2.74911 6.31888 3.84329 5.07426 5.10159C3.82964 6.35989 2.73543 9.109 2.73543 10.9828V17.794C2.73543 19.2985 3.96638 20.5294 5.47087 20.5294H21.8698C23.3743 20.5294 24.6053 19.2985 24.6053 17.794V5.48455C24.6053 3.98006 23.3743 2.74911 21.8698 2.74911H10.9417Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.076 19.1605H2.10649C1.35424 19.1605 0.73877 18.5451 0.73877 17.7928C0.73877 17.0406 1.35424 16.4251 2.10649 16.4251H4.076C4.82825 16.4251 5.44372 17.0406 5.44372 17.7928C5.44372 18.5451 4.82825 19.1605 4.076 19.1605Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5665 23.2646H21.3086C20.5564 23.2646 19.9409 22.6491 19.9409 21.8968C19.9409 21.1446 20.5564 20.5291 21.3086 20.5291H28.8311V19.3666C28.8311 18.6143 29.4466 17.9988 30.1988 17.9988C30.951 17.9988 31.5665 18.6143 31.5665 19.3666V23.2646Z",
    fill: "#999999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6642 25.9999C11.4075 25.9999 9.56104 24.1535 9.56104 21.8968H12.2965C12.2965 22.649 12.9119 23.2645 13.6642 23.2645C14.4164 23.2645 15.0319 22.649 15.0319 21.8968H17.7673C17.7673 24.1535 15.9209 25.9999 13.6642 25.9999Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupcaravans);
export default __webpack_public_path__ + "static/media/Groupcaravans.bf1bdb2f24bfb7cb4b761e2dc99cad96.svg";
export { ForwardRef as ReactComponent };